//istanbul ignore file
import Link from '@mui/material/Link';
import NextLink from 'next/link';

type UnderlinedLinkProps = {
  href: string;
  children?: React.ReactNode;
  openNewTab?: boolean;
  color?: string;
  hoverColor?: string;
};

const UnderlinedLink = ({
  href,
  children,
  color,
  openNewTab = true,
  hoverColor
}: UnderlinedLinkProps) => (
  <Link
    component={NextLink}
    href={href}
    sx={theme => ({
      cursor: 'pointer',
      color: color ?? theme.palette.primary.main,
      ...(hoverColor && {
        '&:hover': {
          color: 'white'
        }
      })
    })}
    underline="always"
    {...(openNewTab && {
      target: '_blank',
      rel: 'noopener'
    })}
  >
    {children}
  </Link>
);

export default UnderlinedLink;
